const CaseSubTypeMap = {
  DEVELOPER: {
    TERMSHEET: 5,
    PAYMENTS: 6,
    REFUND: 15
  },
  BROKER: {
    TERMSHEET: 8,
    PAYMENTS: 9,
    REFUND: 15
  },
  MAKAAN: {
    TERMSHEET: 10,
    PAYMENTS: 11,
    REFUND: 15
  },
  OWNER: {
    PAYMENTS: 14,
    REFUND: 15
  },
  BROKER_ORDER: 3
}
const TERMSHEET_STATUS = [1, 2, 11, 24, 55, 102]
const PAYMENTS_STATUS = [1, 2, 11, 24, 25, 26, 27, 28, 58, 75, 76, 77, 78]
const BROKER_ORDER_STATUS = [1, 2, 11, 23, 24, 25, 26, 27, 28, 41, 42]
const OrderTypes = [
  {
    label: 'Developer Termsheet',
    caseSubType: 'TERMSHEET',
    caseSubTypeId: CaseSubTypeMap.DEVELOPER.TERMSHEET
  },
  {
    label: 'Developer Payments',
    caseSubType: 'PAYMENTS',
    caseSubTypeId: CaseSubTypeMap.DEVELOPER.PAYMENTS
  },
  {
    label: 'Broker Termsheet',
    caseSubType: 'TERMSHEET',
    caseSubTypeId: CaseSubTypeMap.BROKER.TERMSHEET
  },
  {
    label: 'Broker Payments',
    caseSubType: 'PAYMENTS',
    caseSubTypeId: CaseSubTypeMap.BROKER.PAYMENTS
  },
  {
    label: 'Makaan Termsheet',
    caseSubType: 'TERMSHEET',
    caseSubTypeId: CaseSubTypeMap.MAKAAN.TERMSHEET
  },
  {
    label: 'Makaan Payments',
    caseSubType: 'PAYMENTS',
    caseSubTypeId: CaseSubTypeMap.MAKAAN.PAYMENTS
  },
  {
    label: 'Owner Payments',
    caseSubType: 'PAYMENTS',
    caseSubTypeId: CaseSubTypeMap.OWNER.PAYMENTS
  }
]
const paymentSearchKeysObj = {
  paymentsId: 'paymentsId',
  salesForceId: 'salesForceId'
}
const dashboardEntities = {
  'termsheet-rcm-pool': {
    name: 'RCM Termsheet Pool',
    addAsFilter: true,
    statusId: 2,
    caseSubTypeId: CaseSubTypeMap.TERMSHEET,
    key: 'BASED_ON_OUTER_FILTER'
  },
  'termsheet-rcm-new': {
    name: 'RCM New Termsheets',
    addAsFilter: true,
    statusId: 1,
    caseSubTypeId: CaseSubTypeMap.TERMSHEET,
    key: 'BASED_ON_OUTER_FILTER_WITH_AGENT_FILTER',
    addAgent: true
  },
  'termsheet-rcm-followup': {
    useDateFilter: true,
    name: 'RCM FollowUp Termsheets',
    addAsFilter: true,
    statusId: 11,
    caseSubTypeId: CaseSubTypeMap.TERMSHEET,
    key: 'BASED_ON_OUTER_FILTER_WITH_AGENT_FILTER',
    addAgent: true,
    dateFilter: 'fupTime'
  },
  'termsheet-rcm-approved': {
    useDateFilter: true,
    addAsFilter: true,
    name: 'RCM Approved Termsheets',
    key: 'BASED_ON_OUTER_FILTER_WITH_AGENT_FILTER',
    statusId: [55],
    defaultTime: true,
    caseSubTypeId: CaseSubTypeMap.TERMSHEET,
    addAgent: true,
    dateFilter: 'updatedAt'
  },
  'termsheet-rcm-autoapproved': {
    useDateFilter: true,
    addAsFilter: true,
    name: 'Auto Approved Termsheets',
    key: 'BASED_ON_OUTER_FILTER_WITH_AGENT_FILTER',
    statusId: [102],
    defaultTime: true,
    caseSubTypeId: CaseSubTypeMap.TERMSHEET,
    addAgent: true,
    dateFilter: 'updatedAt'
  },
  'termsheet-rcm-rejected': {
    useDateFilter: true,
    addAsFilter: true,
    statusId: 24,
    name: 'RCM Rejected Termsheets',
    key: 'BASED_ON_OUTER_FILTER_WITH_AGENT_FILTER',
    defaultTime: true,
    caseSubTypeId: CaseSubTypeMap.TERMSHEET,
    addAgent: true,
    dateFilter: 'updatedAt'
  },
  'payments-rcm-pool': {
    name: 'RCM Payments Pool',
    addAsFilter: true,
    statusId: 2,
    caseSubTypeId: CaseSubTypeMap.PAYMENTS,
    key: 'BASED_ON_OUTER_FILTER'
  },
  'payments-rcm-new': {
    name: 'RCM New Payments',
    addAsFilter: true,
    statusId: 1,
    isMigrated: false,
    caseSubTypeId: CaseSubTypeMap.PAYMENTS,
    key: 'BASED_ON_OUTER_FILTER_WITH_AGENT_FILTER',
    addAgent: true
    // dateFilter: 'createdAt'
  },
  'payments-rcm-new-migrated': {
    name: 'RCM New Payments Migrated',
    addAsFilter: true,
    statusId: 1,
    isMigrated: true,
    caseSubTypeId: CaseSubTypeMap.PAYMENTS,
    key: 'BASED_ON_OUTER_FILTER_WITH_AGENT_FILTER',
    addAgent: true
    // dateFilter: 'createdAt'
  },
  'payments-rcm-followup': {
    useDateFilter: true,
    name: 'RCM followUp Payments',
    addAsFilter: true,
    statusId: 11,
    caseSubTypeId: CaseSubTypeMap.PAYMENTS,
    key: 'BASED_ON_OUTER_FILTER_WITH_AGENT_FILTER',
    addAgent: true,
    dateFilter: 'fupTime'
  },
  'payments-sent-to-ram': {
    name: 'Sent back to RAM Payments',
    key: 'BASED_ON_OUTER_FILTER_WITH_AGENT_FILTER',
    statusId: 28,
    addAsFilter: true,
    caseSubTypeId: CaseSubTypeMap.PAYMENTS,
    addAgent: true
  },
  'payments-pending-finance-approval': {
    useDateFilter: true,
    name: 'RCM Finance Pending Payments',
    addAsFilter: true,
    dateFilter: 'updatedAt',
    statusId: 25,
    isMigrated: false,
    caseSubTypeId: CaseSubTypeMap.PAYMENTS,
    key: 'BASED_ON_OUTER_FILTER_WITH_AGENT_FILTER',
    addAgent: true
  },
  'payments-pending-finance-approval-migrated': {
    useDateFilter: true,
    name: 'RCM Finance Pending Payments Migrated',
    addAsFilter: true,
    dateFilter: 'updatedAt',
    statusId: 25,
    isMigrated: true,
    caseSubTypeId: CaseSubTypeMap.PAYMENTS,
    key: 'BASED_ON_OUTER_FILTER_WITH_AGENT_FILTER',
    addAgent: true
  },
  'payments-late-cheque-approval-pending': {
    name: 'RCM Late Cheque Approval Pending Payments',
    addAsFilter: true,
    statusId: 87,
    caseSubTypeId: CaseSubTypeMap.PAYMENTS,
    key: 'BASED_ON_OUTER_FILTER_WITH_AGENT_FILTER',
    addAgent: true
  },
  'refund-pending-finance-approval': {
    name: 'RCM Finance Pending Refunds',
    addAsFilter: true,
    statusId: 25,
    caseSubTypeId: 15,
    key: 'BASED_ON_OUTER_FILTER_WITH_AGENT_FILTER',
    addAgent: true
  },
  'refund-rcm-new': {
    name: 'RCM New Refunds',
    addAsFilter: true,
    statusId: 1,
    caseSubTypeId: 15,
    key: 'BASED_ON_OUTER_FILTER_WITH_AGENT_FILTER',
    addAgent: true
  },
  'payments-rcm-rejected-cases': {
    useDateFilter: true,
    addAsFilter: true,
    statusId: 24,
    dateFilter: 'updatedAt',
    name: 'RCM Rejected Payments',
    key: 'BASED_ON_OUTER_FILTER_WITH_AGENT_FILTER',
    caseSubTypeId: CaseSubTypeMap.PAYMENTS,
    addAgent: true
  },
  'payments-finance-approved': {
    useDateFilter: true,
    statusId: 26,
    name: 'Finance Cleared Payments',
    key: 'BASED_ON_OUTER_FILTER_WITH_AGENT_FILTER',
    caseSubTypeId: CaseSubTypeMap.PAYMENTS,
    addAsFilter: true,
    addAgent: true,
    dateFilter: 'updatedAt'
  },
  'payments-finance-rejected': {
    useDateFilter: true,
    addAsFilter: true,
    name: 'Finance Rejected Payments',
    key: 'BASED_ON_OUTER_FILTER_WITH_AGENT_FILTER',
    statusId: 27,
    caseSubTypeId: CaseSubTypeMap.PAYMENTS,
    defaultTime: true,
    addAgent: true,
    dateFilter: 'updatedAt'
  },
  'pending-sales-approval': {
    name: 'Pending Sales Approval',
    addAsFilter: true,
    statusId: 23,
    caseSubTypeId: CaseSubTypeMap.BROKER_ORDER,
    key: 'BASED_ON_OUTER_FILTER'
  },
  'rcm-pool': {
    name: 'RCM Pool',
    addAsFilter: true,
    statusId: 2,
    caseSubTypeId: CaseSubTypeMap.BROKER_ORDER,
    key: 'BASED_ON_OUTER_FILTER'
  },
  'rcm-new': {
    name: 'RCM New Assigned',
    addAsFilter: true,
    statusId: 1,
    caseSubTypeId: CaseSubTypeMap.BROKER_ORDER,
    key: 'BASED_ON_OUTER_FILTER_WITH_AGENT_FILTER',
    addAgent: true
  },
  'rcm-followup': {
    useDateFilter: true,
    name: 'RCM Followup',
    addAsFilter: true,
    statusId: 11,
    caseSubTypeId: CaseSubTypeMap.BROKER_ORDER,
    key: 'BASED_ON_OUTER_FILTER_WITH_AGENT_FILTER',
    addAgent: true,
    dateFilter: 'fupTime'
  },
  'check-due': {
    useDateFilter: true,
    name: 'Check Due',
    addAsFilter: true,
    caseSubTypeId: CaseSubTypeMap.BROKER_ORDER,
    key: 'BASED_ON_OUTER_FILTER_WITH_AGENT_FILTER',
    addAgent: true,
    dateFilter: 'paymentExpectedDepositDate'
  },
  'pending-finance-approval': {
    name: 'Pending Finance Approval',
    addAsFilter: true,
    statusId: 25,
    caseSubTypeId: CaseSubTypeMap.BROKER_ORDER,
    key: 'BASED_ON_OUTER_FILTER_WITH_AGENT_FILTER',
    addAgent: true
  },
  'finance-tat-breach': {
    name: 'Finance TAT Breached',
    addAsFilter: true,
    statusId: 42,
    caseSubTypeId: CaseSubTypeMap.BROKER_ORDER,
    key: 'BASED_ON_OUTER_FILTER_WITH_AGENT_FILTER',
    addAgent: true
  },
  'rcm-rejected-cases': {
    useDateFilter: true,
    addAsFilter: true,
    name: 'RCM Rejected Cases',
    statusId: 24,
    key: 'BASED_ON_OUTER_FILTER_WITH_AGENT_FILTER',
    defaultTime: true,
    caseSubTypeId: CaseSubTypeMap.BROKER_ORDER,
    addAgent: true,
    dateFilter: 'updatedAt'
  },
  'finance-approved-auto': {
    useDateFilter: true,
    name: 'Finance Approved Auto',
    key: 'FINANCE_APPROVED_CASES_AUTO',
    caseSubTypeId: CaseSubTypeMap.BROKER_ORDER,
    defaultTime: true,
    addAgent: false
  },
  'finance-approved-manual': {
    useDateFilter: true,
    name: 'Finance Approved Manual',
    key: 'FINANCE_APPROVED_CASES_MANUAL',
    caseSubTypeId: CaseSubTypeMap.BROKER_ORDER,
    defaultTime: true,
    addAgent: false
  },
  'finance-rejected-auto': {
    useDateFilter: true,
    name: 'Finance Rejected Auto',
    key: 'FINANCE_REJECTED_CASES_AUTO',
    caseSubTypeId: CaseSubTypeMap.BROKER_ORDER,
    defaultTime: true,
    addAgent: false
  },
  'finance-rejected-manual': {
    useDateFilter: true,
    name: 'Finance Rejected Manual',
    key: 'FINANCE_REJECTED_CASES_MANUAL',
    caseSubTypeId: CaseSubTypeMap.BROKER_ORDER,
    defaultTime: true,
    addAgent: true
  },
  'sent-to-ram': {
    name: 'Sent Back To RAM',
    key: 'BASED_ON_OUTER_FILTER_WITH_AGENT_FILTER',
    statusId: 28,
    addAsFilter: true,
    caseSubTypeId: CaseSubTypeMap.BROKER_ORDER,
    addAgent: true
  }
}
const brokerOnlyKeys = [
  'payments-rcm-new-migrated',
  'payments-pending-finance-approval-migrated'
]
const dashboardEntityKeys = {
  paymentEntities: [],
  termsheetEntities: [],
  refundEntities: [],
  brokerEntities: []
}
Object.keys(dashboardEntities).forEach(key => {
  if (key.startsWith('payments-')) {
    dashboardEntityKeys.paymentEntities.push(key)
  } else if (key.startsWith('termsheet-')) {
    dashboardEntityKeys.termsheetEntities.push(key)
  } else if (key.startsWith('refund-')) {
    dashboardEntityKeys.refundEntities.push(key)
  } else {
    dashboardEntityKeys.brokerEntities.push(key)
  }
})
dashboardEntityKeys.NonBrokerPaymentKeys =
  dashboardEntityKeys.paymentEntities.filter(
    key => brokerOnlyKeys.indexOf(key) === -1
  )
const constant = {
  epochToDate: epoch => {
    if (!epoch) return ''
    const options = { year: 'numeric', month: 'short', day: 'numeric' }
    return new Date(epoch).toLocaleString('en-GB', options).split(',')[0]
  },
  epochToDateTime: epoch => {
    if (!epoch) return ''
    const options = { timeZone: 'Asia/Kolkata' }
    return new Date(epoch).toLocaleString('en-GB', options)
  },
  pageSize: 50,
  minDateAllowed: new Date(
    new Date().setFullYear(new Date().getFullYear() - 100)
  ),
  maxDateAllowed: new Date(
    new Date().setFullYear(new Date().getFullYear() + 100)
  ),
  dashboardEntities,
  dashboardEntityKeys: {
    BROKER: {
      paymentEntities: dashboardEntityKeys.paymentEntities,
      termsheetEntities: dashboardEntityKeys.termsheetEntities,
      refundEntities: dashboardEntityKeys.refundEntities
    },
    DEVELOPER: {
      paymentEntities: dashboardEntityKeys.NonBrokerPaymentKeys,
      termsheetEntities: dashboardEntityKeys.termsheetEntities,
      refundEntities: dashboardEntityKeys.refundEntities
    },
    MAKAAN: {
      paymentEntities: dashboardEntityKeys.NonBrokerPaymentKeys,
      termsheetEntities: dashboardEntityKeys.termsheetEntities,
      refundEntities: dashboardEntityKeys.refundEntities
    },
    OWNER: {
      paymentEntities: dashboardEntityKeys.NonBrokerPaymentKeys,
      termsheetEntities: [],
      refundEntities: dashboardEntityKeys.refundEntities
    },
    brokerEntities: dashboardEntityKeys.brokerEntities
  },
  noMassAssignKeys: [
    'pending-sales-approval',
    'rcm-rejected-cases',
    'finance-rejected-manual',
    'finance-rejected-auto',
    'finance-approved-manual',
    'finance-approved-auto',
    'payments-sent-to-ram',
    'payments-rcm-rejected-cases',
    'payments-finance-approved',
    'payments-finance-rejected',
    'termsheet-rcm-approved',
    'termsheet-rcm-rejected',
    'termsheet-rcm-autoapproved'
  ],
  noMassAssignStatusIds: [23, 24, 26, 27, 28, 41, 55, 58],
  /* status: {
    1: 'New',
    2: 'New Unassigned',
    11: 'Followup',
    23: 'Pending Sales Approval',
    24: 'Rejected by RCM',
    25: 'Pending Finance Approval',
    26: 'Finance Approved',
    27: 'Finance Rejected',
    28: 'Sent To RAM',
    41: 'Rejected by Sales',
    42: 'Finance TAT Breach',
    55: 'RCM Approved',
    58: 'Payments Refunded'
  }, */
  orderTypeStatusMap: {
    BROKER_ORDER: BROKER_ORDER_STATUS,
    PAYMENTS: PAYMENTS_STATUS,
    TERMSHEET: TERMSHEET_STATUS
  },
  /* paymentsRefundStatusCategories: [75, 76, 77, 78], */
  makaanCaseSubTypes: [
    CaseSubTypeMap.MAKAAN.PAYMENTS,
    CaseSubTypeMap.MAKAAN.TERMSHEET
  ],
  // readOnlyStatus: [2, 23, 24, 27, 28, 41, 58],
  followupStatus: [11],
  documentTypes: {
    BROKER_ORDER: [
      'Cheque',
      'Deposit slip',
      'Term sheet',
      'Proforma invoice',
      'Miscellaneous'
    ].map(key => ({ label: key, value: key })),
    TERMSHEET: [{ label: 'Signed Termsheet', value: 'SignedTermsheet' }],
    PAYMENTS: [
      { label: 'Cheque', value: 'Cheque' },
      { label: 'Deposit Slip', value: 'DepositSlip' },
      { label: 'Demand Draft', value: 'DemandDraft' },
      { label: 'Credit Approval', value: 'CreditApproval' }
    ]
  },
  validImageTypes: ['image/gif', 'image/jpeg', 'image/png'],
  configUrls: {
    ORDER_GET: orderId => `/mystique/rcm/v1/${orderId}`,
    BROKER_PUT: orderId => `/mystique/rcm/v1/housing-broker-sales/${orderId}`,
    PAYMENTS_PUT: () => '/mystique/rcm/v1/housing-developer-payments/payments',
    PAYMENTS_MODE_POST: () => '/sapna/rcm/change-payment-mode',
    TERMSHEET_PUT: () =>
      '/mystique/rcm/v1/housing-developer-termsheet/termsheet',
    REFUND_PUT: () => `/mystique/rcm/v1/housing-developer-refund`,
    PACKAGE_DETAILS: () => '/mystique/rcm/v1/housing_packages',
    REASON_LIST: (currentStatusId, caseSubTypeId) =>
      `/mystique/v1/reference-data/case-reason-status-mapping?filters=currentStatusId==${currentStatusId};caseTypeId==7;caseSubTypeId==${caseSubTypeId};active==true`,
    MASTER_REASON_LIST: () => '/mystique/v1/reference-data/case-reasons',
    CASE_STATUS_MAP: () => '/mystique/v1/reference-data/case-assign-status',
    PAYMENT_STATUS_MAP: () => '/sapna/v1/reference-data/master-payment-modes'
  },
  CaseSubTypeMap,
  orderTypes: OrderTypes,
  entityTableFields: {
    BROKER_ORDER: [
      { label: 'Id', field: 'id', isLink: true },
      { label: 'Order Id', field: 'orderId' },
      { label: 'Status', field: 'status' },
      { label: 'Agent', field: 'agentName' }
    ],
    PAYMENTS: [
      { label: 'Id', field: 'id', isLink: true },
      { label: 'Payments Id', field: 'paymentsId' },
      { label: 'Milestone Id', field: 'milestoneId' },
      { label: 'City', field: 'cityName' },
      { label: 'Reference Number', field: 'referenceNumber' },
      { label: 'Status', field: 'status' },
      { label: 'Agent', field: 'agentName' },
      { label: 'Created At', field: 'createdAtDate' }
    ],
    TERMSHEET: [
      { label: 'Id', field: 'id', isLink: true },
      { label: 'Termsheet Id', field: 'termsheetId' },
      { label: 'Termsheet Number', field: 'termsheetNumber' },
      { label: 'City', field: 'cityName' },
      { label: 'Opportunity Id', field: 'opportunityId' },
      { label: 'Status', field: 'status' },
      { label: 'Agent', field: 'agentName' },
      { label: 'Created At', field: 'createdAtDate' }
    ],
    REFUND: [
      { label: 'Id', field: 'id', isLink: true },
      { label: 'Termsheet Id', field: 'termsheetId' },
      { label: 'Opportunity Id', field: 'opportunityId' },
      { label: 'Source Payment Id', field: 'sourcePaymentId' },
      { label: 'City', field: 'cityName' },
      { label: 'Status', field: 'status' },
      { label: 'Agent', field: 'agentName' },
      { label: 'Created At', field: 'createdAtDate' }
    ],
    YESBANKWALLETCLEARED: [
      {
        label: 'CustomerName',
        key: 'drawerName'
      },
      {
        label: 'Bank',
        key: 'bankName'
      },
      {
        label: 'Type',
        key: 'type'
      },
      {
        label: 'Amount',
        key: 'amount'
      },
      {
        label: 'Payment Received Date',
        key: 'paymentReceivedDate',
        type: 'Date'
      },
      {
        label: 'Reference Number',
        key: 'referenceNumber'
      }
    ],
    YESBANKWALLETBOUNCED: [
      {
        label: 'CustomerName',
        key: 'drawerName'
      },
      {
        label: 'Bounced Reason',
        key: 'bouncedReason',
        textColor: 'red'
      },
      {
        label: 'Type',
        key: 'type'
      },
      {
        label: 'Amount',
        key: 'amount'
      },
      {
        label: 'Payment Received Date',
        key: 'paymentReceivedDate',
        type: 'Date'
      },
      {
        label: 'Reference Number',
        key: 'referenceNumber'
      }
    ],
    SELLERWALLET: [
      {
        label: 'ID',
        key: 'id'
      },
      {
        label: 'Payment Date',
        key: 'paymentDate',
        type: 'Date'
      },
      {
        label: 'Reference Number',
        key: 'referenceNumber'
      },
      {
        label: 'Amount',
        key: 'amount',
        textColor: 'green'
      },
      {
        label: 'Remaining Amount',
        key: 'remainingAmount',
        textColor: 'blue'
      }
    ]
  },
  paymentSearchKeysObj,
  paymentSearchKeys: [
    {
      label: 'Payments Id',
      key: paymentSearchKeysObj.paymentsId
    },
    {
      label: 'Salesforce Id',
      key: paymentSearchKeysObj.salesForceId
    }
  ],
  keySearchUrlsMap: {
    BROKER_ORDER: '/mystique/rcm/v1/key-search?rcmSelectorsArray=',
    PAYMENTS:
      '/mystique/rcm/v1/housing-developer-payments/payments/key-search?paymentSelectorsArray=',
    TERMSHEET:
      '/mystique/rcm/v1/housing-developer-termsheet/termsheet/key-search?termsheetSelectorsArray=',
    REFUND:
      '/mystique/rcm/v1/housing-developer-refund/key-search?refundSelectorsArray='
  },
  ticketingCategories: [
    {
      id: 39,
      name: 'Order Cancellation'
    },
    {
      id: 40,
      name: 'Order Modification'
    },
    {
      id: 41,
      name: 'Invoice Generation'
    },
    {
      id: 42,
      name: 'Credit Note'
    }
  ],
  domainId: {
    HOUSING: 5,
    MAKAAN: 1
  },
  roles: {
    rcmAdmin: 'RCM Admin',
    rcmUser: 'HOUSING_RCM_USER',
    housingSalesManager: 'Housing Sales Manager',
    housingSalesAgent: 'Housing Sales Agent',
    rcmPaymentsAdmin: 'RCM Payments Admin',
    rcmView: 'RCM VIEW',
    rcmDataAssignment: 'RCM_DATA_ASSIGNMENT'
  },
  rolesUserManagement: {
    rcmAdmin: 'RCM Admin',
    housingRcmUser: 'HOUSING_RCM_USER',
    rcmUser: 'RCM_USER',
    rcmPaymentsAdmin: 'RCM Payments Admin',
    rcmView: 'RCM VIEW',
    rcmUserManagement: 'RCM_USER_MANAGEMENT',
    rcmDataAssignment: 'RCM_DATA_ASSIGNMENT'
  },
  configMsgs: {
    required: 'This field is required.'
  },
  regex: {
    email:
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  },
  DATE_FORMAT: 'YYYY-MM-DD',
  valueToId: obj => {
    const result = {}
    Object.keys(obj).forEach(key => {
      result[obj[key]] = key
    })
    return result
  },
  paymentStatuses: {
    1: 'CLEARED',
    2: 'BOUNCED',
    3: 'DEPOSITED',
    4: 'COLLECTED'
  },
  paymentModes: {
    1: 'CHEQUE',
    2: 'ONLINE',
    3: 'CASH'
  },
  months:
    '_January_February_March_April_May_June_July_August_September_October_November_December'.split(
      '_'
    ),
  pendingFinanceApprovalStatusId: 25,
  newFollowupStatusIds: [1, 11],
  handoverDateMandatoryReasons: [143, 144],
  rejectedAfterApproval: 'Rejected after approval',
  autoAssignKey: 'termsheet-rcm-autoapproved',
  FINANCE_APPROVED: 26,
  getErrorMessage: err => {
    let errorMessage
    if (err) {
      if (err.response) {
        const { status, data } = err.response
        if (status === 400 || status === 401 || status === 500) {
          errorMessage =
            (data && data.error && data.error.msg) ||
            (data && data.message && data.message[0]) ||
            err.message
        }
      } else if (err.message) return err.message
    }
    return errorMessage || 'Alas! Some error occurred.'
  }
}

export default constant



/** WEBPACK FOOTER **
 ** ./src/utils/CommonConstants.js
 **/